import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

import { DetailsComponent } from '../details.component';
import { CommandService } from 'src/app/services/common/command.service';
import { AlertService } from 'src/app/services/common/alert.service';
import { Routes } from 'src/app/constants/routes.constant';
import { OrderStatusEnum } from 'src/app/models/order/enums/order-status.enum';
import { GoogleAnalyticsService } from 'src/app/services/common/google-analytics.service';

@Component({
    selector: 'order-details-mobile',
    templateUrl: './details-mobile.component.html',
    styleUrls: ['./../details.component.scss', './details-mobile.component.scss'],
    standalone: false
})
export class DetailsMobileComponent extends DetailsComponent implements OnInit {
  cancelOrderMobile : string = "order-mobile-cancel-booking";
  orderEditRoute = Routes.ORDER.EDIT;
  statusEnum: typeof OrderStatusEnum = OrderStatusEnum;
  type : string;
  cancelOrdeMobile : string;
  orderMobilePickupAndDeliveryDetails : string;
  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected commandService: CommandService,
    protected alertService: AlertService,
    protected deviceService: DeviceDetectorService,
    protected googleAnalyticsService: GoogleAnalyticsService,
  ) {
    super(route, router, commandService, alertService, deviceService, googleAnalyticsService)
  }

  ngOnInit() {
    this.type = this.route.snapshot.paramMap.get('type');
    super.initData();
    this.cancelOrdeMobile = "order-mobile-cancel-booking";
    this.orderMobilePickupAndDeliveryDetails ="order-mobile-pickup-and-delivery-details";
  }

}
